<script>
const Y_ACTIVATE_COLOR = 50;
let shouldColorHeader = false;
let shouldActivateLink = false;
let links = [
    {
        id: '#company-values',
        active: false,
        description: 'Valores',
    },
    {
        id: '#about-us',
        active: false,
        description: 'Sobre nós'
    },
    {
        id: '#products',
        active: false,
        description: 'Produtos'
    },
//    {
//        id: '#partners',
//        active: false,
//        description: 'Parceiros'
//    },
    {
        id: '#get-in-touch',
        active: false,
        description: 'Entre em contato'
    },
]

window.addEventListener('scroll', () => {
    colorHeaderBackgroundFn()
})

function colorHeaderBackgroundFn() {
    if (window.pageYOffset > Y_ACTIVATE_COLOR) {
        shouldColorHeader = true;
    } else {
        shouldColorHeader = false;
    }
}

function goToTop() {
    location.hash = '#'
    window.scrollTo(0, 0)
}

function activateLinkFn(chosenLink) {
    for (let i = 0; i < links.length; i++) {
        links[i].active = false;
    }

    chosenLink.active = true;
    location.hash = chosenLink.id
}
</script>

<header class:colored={shouldColorHeader}>
    {#if shouldColorHeader}
    <img src="./assets/logo_horizontal.png" alt="C2B Software" on:click={goToTop}>
    {:else}
    <img src="./assets/logo_horizontal_white.png" alt="C2B Software" on:click={goToTop}>
    {/if}

    <nav>
        <ul>
            {#each links as link}
            <li on:click={() => activateLinkFn(link)}
                class={link.active ? 'active': ''}>
                <a href={link.id}>{link.description}</a>
            </li>
            {/each}
        </ul>
    </nav>
</header>

<style>
header {
    position: fixed;
    color: #fff;
    width: 100%;
    text-align: center;
    top: 0;
    background-color: transparent;
    z-index: 999;
    transition: background-color .5s ease;
}

header.colored {
    background-color: #fff;
    border-bottom: 1px solid #F86754;
}

header a {
    color: #fff;
    text-decoration: none;
}

header>img {
    width: 100px;
    height: 25px;
    margin-top: 25px;
    margin-left: 15px;
    margin-bottom: 15px;
}

header>nav {
    float: right;
    padding-right: 15px;
}

header>nav>ul {
    list-style: none;
    padding-left: 0;
}

header>nav>ul>li {
    display: inline-block;
    padding: 5px 0 10px;
    margin: 10px;
}

header>nav>ul>li:hover {
    cursor: pointer;
}

header>nav>ul>li.active {
    border-bottom: 2px solid #F86754;
}

nav {
    display: none;
}

@media(min-width: 768px) {
    header {
        text-align: left;
    }

    header>img {
        width: 160px;
        height: 40px;
        margin-top: 25px;
        margin-left: 15px;
    }

    header.colored a {
        color: #666;
    }

    header.colored {
        background-color: #fff;
        color: #666;
        border-bottom: none;
    }

    nav {
        display: block;
    }
}
</style>
